import { combineReducers } from 'redux';
// import alert from './alert';
import auth from './auth';
import state from './state';
import student from './student';
import config from './config';
import branch from './branch';
// import dashboard from './dashboard';
import fight from './fightReducer';
import jump from './jump';
import book from './book';
import learnFight from './learn-fight';
import hatchEgg from './hatch-egg';

export default combineReducers({
  // alert,
  auth,
  state,
  student,
  config,
  branch,
  fight,
  jump,
  book,
  learnFight,
  // dashboard
  hatchEgg,
});
